<template>
<div>
  <estatisticasAno></estatisticasAno>
  <div class="mt-2">
    <!-- <estatisticasHora></estatisticasHora> -->
  </div>
</div>
</template>
<script>
import EstatisticasAno from './../components/estatisticasAno'
import EstatisticasHora from './../components/chartLiberacaoPorHora'
export default {
  data () {
    return {
      nameApp: ''
    }
  },
  components: {
    estatisticasAno: EstatisticasAno,
    // eslint-disable-next-line vue/no-unused-components
    estatisticasHora: EstatisticasHora
  },
  props: {},
  mounted () {
  }
}
</script>

<style scoped>
</style>
